skrilla.directive('betLedger', function ($window) {
  return {
    templateUrl: 'directives/betLedger/betLedger.html',
    scope: {
      key: "=",
      type: "="

    },
    controller: function ($scope, searchService, queryService, dateService, csvService) {
      $scope.reset = function() {
        $scope.firstDate = moment().utc().subtract(1, "month").startOf("month").toDate();
        $scope.lastDate = moment().utc().startOf("month").toDate();
      };
      $scope.reset();

      $scope.generateFilename = function () {
        $scope.exportFilename = $scope.getFilename();
      }
      $scope.getFilename = function () {
        const formatDateTime = function (value) {
          let dateTime = moment.utc(value);
          return dateTime.format("DD-MM-yyyy-HH-mm-ss")
        }
        if ($scope.firstDate && $scope.lastDate) {
          return "bet_ledgers_" + formatDateTime($scope.firstDate) + "_-_" + formatDateTime($scope.lastDate) + ".csv";
        } else {
          return "bet_ledgers.csv";
        }
      }
      $scope.formatDateTime = function (value) {
        let dateTime = moment.utc(value);
        return dateTime.format("DD/MM/yyyy HH:mm:ss")
      }

      $scope.exportCsv = function () {
        const firstDate = $scope.firstDate ? dateService.compensateForTimezone($scope.firstDate) : $scope.firstDate;
        const lastDate = $scope.lastDate ? dateService.compensateForTimezone($scope.lastDate) : $scope.lastDate;
        csvService.openInV2CSVExporter('ntrcBetLedger', {firstDate, lastDate})
      }

    }
  };
});
